/* eslint-disable max-len */
import React from 'react'
import { Icon, Props } from './Icon'

export const IconOverride = ({ size = 24, ...props }) => (
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size} 
      height={size}
      viewBox="0 0 20 20.04"
      {...props}
    >
      {/* Orange portion */}  
      <path 
        d="M0 12.32V15.4h12.32V3.85L8.47 0H0v5.39z" 
        fill="#f06e36" 
        fillRule="nonzero" 
      />
      {/* Gray portion */}
      <path 
        d="M9.22 16.96h4.6l-6.14 0v3.08H20V8.49l-3.85-3.84h-2.33v12.29" 
        fill="#adacaf" 
        fillRule="nonzero" 
      />
    </svg>
  </Icon>
)

IconOverride.displayName = 'IconOverride'
